if (!customElements.get('almila-product-metadata')) {
  customElements.define('almila-product-metadata', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.oldPriceWatch?.disconnect();
      this.form = this.closest('form.add-to-cart-form');
      if (!this.form) return;
      try {
        this.variants = JSON.parse(this.dataset.variants);
      } catch {
        this.variants = [];
      }
      this.abort = new AbortController();
      this.form.addEventListener('change', (event) => {
        if (/^option[1-3]$/.test(event.target.name)) this.update();
      }, { capture: true, signal: this.abort.signal });
      this.watchOldPrice();
      // Preserve Shopify's server-selected variant until the customer changes options.
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.oldPriceWatch?.disconnect();
      this.form = null;
    }

    // After every option choice the theme's variant script (app.js productForm.validate, changeProductPrices)
    // writes the variant's compare-at price into the old price. For a variant without a higher compare-at price
    // that value is never set, so the text "undefined" is written. The theme hides the element only when the
    // compare-at price is empty, and then only the first old price in the document: a compare-at price at or
    // below the price (or a sale card in the cart drawer above the page) leaves "undefined" struck through beside
    // a pink price (almila-product-layout.css). That text is cleared and the element hidden. A real old price
    // that is still hidden (the theme set inline-flex on the drawer card, not here) is shown again the way the
    // theme shows it. The observer runs right after the theme's handler, before the next paint.
    watchOldPrice() {
      const oldPrice = this.form.querySelector('#pdp-prices .js-price-compare');
      if (!oldPrice) return;
      this.oldPriceWatch = new MutationObserver(() => {
        const text = oldPrice.textContent.trim();
        if (text === String(undefined)) {
          oldPrice.textContent = '';
          oldPrice.style.display = 'none';
        } else if (text && oldPrice.style.display === 'none') {
          oldPrice.style.display = 'inline-flex';
        }
      });
      this.oldPriceWatch.observe(oldPrice, { childList: true });
    }

    update() {
      const controls = [1, 2, 3].map(position => this.form.querySelector(`select[name="option${position}"]`));
      const hasOptions = controls.some(Boolean);
      const variant = this.variants.find(record => hasOptions
        ? record.options.every((value, index) => controls[index]?.value === value)
        : record.id === this.dataset.initialVariant);
      const sku = variant?.sku || '';
      this.querySelector('[data-sku-value]').textContent = sku;
      this.querySelector('[data-sku-row]').hidden = !sku.trim();
    }
  });
}
